import React, { useState } from "react";
import { saveOffline } from "../offline/offlineManager";

const SaveOfflineButton = ({ selectedService, selectedBand, setError }) => {
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  const handleClick = async () => {
    setSaving(true);
    await saveOffline(selectedService, selectedBand, setError, setMessage);
    setSaving(false);
  };

  return (
    <button onClick={handleClick} className="btn btn-sm btn-outline-secondary ms-2" disabled={saving} title="Save setlist for offline use">
      {saving ? <i className="bi bi-arrow-repeat spin"></i> : <i className="bi bi-download"></i>}
    </button>
  );
};

export default SaveOfflineButton;
